module.exports = __webpack_public_path__ + "img/biaoti_zhuanjia.1c3cb36b.png";